import { defineMessages } from 'react-intl'


export default defineMessages({
  cookieRefresh: {
    defaultMessage: 'Cookie Refresh: {cookieRefresh}',
    id: 'tcf-details.cookie-refresh',
  },

  dataCategories: {
    defaultMessage: 'Data Categories',
    id: 'tcf-details.data-categories',
  },

  description: {
    defaultMessage: 'Description',
    id: 'tcf-details.description',
  },

  example: {
    defaultMessage: 'Example',
    id: 'tcf-details.example',
  },

  features: {
    defaultMessage: 'Features',
    id: 'tcf-details.features',
  },

  maxDeviceStorageDuration: {
    defaultMessage: 'Max Device Storage Duration: {maxDeviceStorageDuration, plural, =0 {unspecified} =1 {1 day} other {# days}}',
    id: 'tcf-details.max-device-storage-duration',
  },

  retentionDays: {
    defaultMessage: '{number, plural, =0 {unspecified} =1 {1 day} other {# days}}',
    id: 'tcf-details.retention-days',
  },

  privacyPolicy: {
    defaultMessage: 'Privacy Policy',
    id: 'tcf-details.privacy-policy',
  },

  purposes: {
    defaultMessage: 'Purposes',
    id: 'tcf-details.purposes',
  },

  sdkDisclosure: {
    defaultMessage: 'SDK Disclosure',
    id: 'tcf-details.sdk-disclosure',
  },

  specialFeatures: {
    defaultMessage: 'Special Features',
    id: 'tcf-details.special-features',
  },

  specialPurposes: {
    defaultMessage: 'Special Purposes',
    id: 'tcf-details.special-purposes',
  },

  standardDataRetention: {
    defaultMessage: 'Standard Retention Duration',
    id: 'tc-details.standard-data-retention',
  },

  storageAccess: {
    defaultMessage: 'Storage Access',
    id: 'tcf-details.storage-access',
  },

  storageDisclosure: {
    defaultMessage: 'Storage Disclosure',
    id: 'tcf-details.storage-disclosure',
  },

  usesCookies: {
    defaultMessage: 'Uses Cookies: {usesCookies}',
    id: 'tcf-details.uses-cookies',
  },

  usesNonCookieAccess: {
    defaultMessage: 'Uses Non-Cookie Access: {usesNonCookieAccess}',
    id: 'tcf-details.uses-non-cookie-access',
  },

  vendorsRequestingContent: {
    defaultMessage: 'Vendors Requesting Consent',
    id: 'tcf-details.vendors-requesting-consent',
  },
})
